import { ref as o } from "vue";
const e = o(!1);
function s() {
  return {
    isMobileMenuOpen: e,
    setMobileMenuOpen: (n) => {
      e.value = n;
    }
  };
}
export {
  s as default
};
//# sourceMappingURL=useMobileMenuNav-es.js.map
